import { AddressDTO } from "./Common";
import { MediaInfoDTO } from "./Media";

export type IClaimHistory = {
    claimNumber: string,
    hin: string,
    customerId: string,
    customerName: string,
    model: string | null,
    modelYear: string | null,
    failureDate: string | null,
    claimStatus: string | null,
    claimStatusDescription: string | null,
    authorizationNumber: string | null,
    claimTotal: string | null,
    preAuthAmount: number | null,
    submitDate: string,
    appovalDate: string | null,
    action: string,
}

interface WarrantyClaimHeaderDTO {
    claimNumber: string;
    hin: string;
    customerId: string;
    customerName: string;
    model?: string;
    modelYear?: string;
    failureDate?: Date;
    claimStatus?: string;
    claimStatusDescription: string;
    authorizationNumber?: string;
    claimTotal?: number;
    preAuthAmount?: number;
    submitDate?: Date;
    appovalDate?: Date;
}

export interface FailureModeDTO {
    lineNumber?: number;
    complaint?: string;
    cause?: string;
    correction?: string;
    repairTech?: string;
}

export type LaborCodeDTO = {
    standardHours?: number;
    allowOverride?: boolean;
    overrideDescription?: boolean;
    overrideRate?: boolean;
    group?: string;
    name: string;
    value: string;
}

export interface ClaimLaborLineDTO extends LaborLineDTO {
    preAuthAmount?: number;
    faultType?: string;
    causeCode?: string;
}

export interface LaborLineDTO {
    lineNumber: number;
    laborCode: LaborCodeDTO; 
    hours: number;
    rate?: number;
    cost?: number;
    lineStatusCode?: string;
}

export interface PartLineDTO {
    lineNumber: number;
    lineStatusCode?: string;
    partNumber: string;
    partDescription: string;
    quantity: number;
    sequenceCode?: string;
    costPer?: number;
    serviceBulletin?: string;
    rmaRequired?: boolean;
    totalCost?: number;
    laborHours?: number;
    laborRate?: number;
}

export interface ClaimPartLineDTO extends PartLineDTO {
    preAuthAmount?: number;
    faultType?: string;
    causeCode?: string;
    partReceived?: boolean;
}

export interface ClaimFailureModeDTO extends FailureModeDTO {
    laborLines: ClaimLaborLineDTO[];
    partLines: ClaimPartLineDTO[];
}

export interface CommentDTO {
    comment?: string;
    commenter?: string;
    commentDate: Date;
    lineNumber?: number;
}


interface ClaimPayableContactDTO {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    address: AddressDTO;
}

export interface WarrantyClaimDTO extends WarrantyClaimHeaderDTO {
    warrantyRegistrationId?: string;
    repairStartDate?: Date;
    repairEndDate?: Date;
    currency?: string;
    memo?: string;
    hourMeterReading?: string;
    returnParts: boolean;
    failureModes: ClaimFailureModeDTO[];
    dealerComments?: CommentDTO[];
    internalComments?: CommentDTO[];
    mediaList: MediaInfoDTO[];
    engineModel?: string;
    serialNumber?: string;
    ownerFirstName?: string;
    ownerLastName?: string;
    ownerEmail?: string;
    ownerPhone?: string;
    ownerAddress?: AddressDTO;
    warrantyType?: string;
    warrantyPurchaseDate?: Date;
    warrantyExpirationDate?: Date;
    overrideClaimPayable?: boolean;
    claimPayableContact: ClaimPayableContactDTO;
    rma?: ReturnMaterialAuthorizationDTO;
    SalesOrderNumber?: number;
}

export const getEmptyPart = (): ClaimPartLineDTO => ({
    lineNumber: 0,
    lineStatusCode: "PEN",
    partNumber: "",
    partDescription: "",
    quantity: 0,
    sequenceCode: "",
    costPer: 0,
    faultType: "",
    causeCode: "",
    serviceBulletin: "",
    rmaRequired: false,
    totalCost: 0,
    preAuthAmount:0
});

export const getEmptyLabor = (): ClaimLaborLineDTO => ({
    lineNumber: 0,
    laborCode: {       
        standardHours: 0,
        allowOverride: false,
        overrideDescription: false,
        overrideRate: false,
        name: "",
        value: ""
    },
    hours: 0,
    rate: 0,
    cost: 0,
    faultType: "",
    causeCode: "",
    lineStatusCode: "PEN",
    preAuthAmount:0
});

export const getEmptyFailureMode = (): ClaimFailureModeDTO => ({
    lineNumber: 0,
    complaint: "",
    cause: "",
    correction: "",
    repairTech: "",
    laborLines: [],
    partLines: []
});  

export const getEmptyAddress = (): AddressDTO => ({
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    country: '',
    zipCode: ''
});

export const getDefaultClaimPayableContact = (): ClaimPayableContactDTO => ({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: getEmptyAddress(),
});

export interface ReturnMaterialAuthorizationDTO {
    rmaNum?: string;
    dateCreated?: Date;
    openRMA?: boolean;
    ageInDays?: string;
    partList: LineItemDTO[]
}

export interface LineItemDTO {
    lineNumber?: number;
    partNum?: string;
    partDescription?: string;
    openRMALine?: boolean;
    qty?: string;
}





